import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var getDefaultStyleSheet = _ref => {
  var {
    backgroundColorToken,
    backgroundColorTokenArgs,
    borderColorToken,
    borderColorTokenArgs,
    designContext,
    isCircle,
    preset,
    size,
    textColorToken,
    textColorTokenArgs
  } = _ref;
  var subtleState = preset === 'subtle' ? 'subtle' : 'default';

  // ⚠️ THIS COMPONENT TOKEN SUPPORTS ARGS WE DON'T USE INTERNALLY ⚠️
  // Keep passing all arguments in case our users use them in custom themes, even if we don't use them ourselves.
  // Any arg removal needs to go through the regular deprecation process.
  var backgroundColor = designContext.get(backgroundColorToken ? backgroundColorToken : 'badge/background-color', _objectSpread({
    preset,
    subtleState
  }, backgroundColorTokenArgs)).toString();
  var finalTextColorToken = textColorToken ? textColorToken : 'badge/text-color';
  var finalTextColorTokenArgs = _objectSpread({
    preset,
    subtleState
  }, textColorTokenArgs);

  // ⚠️ THIS COMPONENT TOKEN SUPPORTS ARGS WE DON'T USE INTERNALLY ⚠️
  // Keep passing all arguments in case our users use them in custom themes, even if we don't use them ourselves.
  // Any arg removal needs to go through the regular deprecation process.
  var textColor = designContext.get(finalTextColorToken, finalTextColorTokenArgs).toString();
  var borderRadius = designContext.get('badge/corner-radius').value();
  var borderWidth = borderColorToken ? designContext.get('badge/border-width').value() : 0;
  var height = designContext.get('badge/height', {
    size
  }).value();

  // ⚠️ THIS COMPONENT TOKEN SUPPORTS ARGS WE DON'T USE INTERNALLY ⚠️
  // Keep passing all arguments in case our users use them in custom themes, even if we don't use them ourselves.
  // Any arg removal needs to go through the regular deprecation process.
  var textStyle = designContext.get('badge/text-style', {
    subtleState
  }).styles();
  return {
    rootStyle: {
      alignItems: 'flex-start',
      position: 'relative'
    },
    innerViewStyle: _objectSpread({
      boxSizing: 'border-box',
      alignItems: 'center',
      backgroundColor,
      borderRadius,
      height,
      width: isCircle ? height : undefined,
      justifyContent: 'center',
      paddingLeft: isCircle ? 0 : 8 - borderWidth,
      paddingRight: isCircle ? 0 : 8 - borderWidth
    }, borderColorToken ? {
      borderWidth,
      borderColor: designContext.get(borderColorToken, borderColorTokenArgs).toString()
    } : {}),
    imageStyle: {
      borderRadius,
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    },
    contentStyle: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    textStyle: _objectSpread(_objectSpread({}, textStyle), {}, {
      color: textColor,
      WebkitFontSmoothing: 'antialiased',
      marginBottom: 0,
      marginTop: 0,
      textAlign: 'center',
      textRendering: 'geometricPrecision'
    }),
    actionIconWrapperStyle: {
      marginLeft: -4,
      marginRight: -4
    },
    actionIconProps: {
      colorToken: finalTextColorToken,
      colorTokenArgs: finalTextColorTokenArgs
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map